import React, { FC } from 'react';
import { AddCardRowProps } from '../WalletSavedCardsSection.types';
import { StyledAddCardRow } from './AddCardRow.styles';

/**
 * AddCardRow - Displays the "Add a Card" row with CTA button
 * Presentational component that receives callbacks from parent
 */
export const AddCardRow: FC<AddCardRowProps> = ({
  title,
  subtitle,
  ctaLabel,
  ctaAriaLabel,
  onAddClick,
  testId,
  showDivider = true,
}) => {
  return (
    <StyledAddCardRow
      data-testid={testId}
      className="wallet-saved-cards-section__add-card-row"
      $showDivider={showDivider}
    >
      <div className="wallet-saved-cards-section__add-card-content">
        <div className="wallet-saved-cards-section__add-card-icon" aria-hidden="true">
          <span>+</span>
        </div>

        <div className="wallet-saved-cards-section__add-card-text">
          <p className="wallet-saved-cards-section__add-card-title">{title}</p>
          <p className="wallet-saved-cards-section__add-card-subtitle">{subtitle}</p>
        </div>
      </div>

      <button
        type="button"
        className="wallet-saved-cards-section__add-cta"
        onClick={onAddClick}
        aria-label={ctaAriaLabel || ctaLabel}
        data-testid="wallet-add-card-cta"
      >
        {ctaLabel}
      </button>
    </StyledAddCardRow>
  );
};
